import React from 'react'
import blockchainVerified from '../../assets/blockchain-verified.PNG'
function Verification({ userBadge, userName, setShowVerification }) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }

  return (
    <div className='verification'>
      <div className='dialog'>
        <div className='d-flex justify-content-between p-2'>
          <div className='meta-title'>Verification</div>
          <button onClick={() => setShowVerification(false)} className='btn-close'></button>
        </div>
        <div>
          <i className='fas fa-check'></i>
          {'  '} Issued on{' '}
          <span className='meta'>{new Date(userBadge.dateIssued).toLocaleDateString('en-GB', options)}</span>
        </div>
        <div>
          <i className='fas fa-check'></i>
          {'  '} Issued by <span className='meta'>{userBadge.issuedBy}</span>
        </div>
        <div>
          <i className='fas fa-check'></i>
          {'  '} Issued to <span className='fw-bold'>{userName}</span>
        </div>
        <div>
          <i className='fas fa-check'></i>
          {'  '}Issued using <span className='fw-bold'>XCBM</span>
        </div>
        <div>
          <i className='fas fa-check'></i>
          {'  '} Authorized by <span className='meta'>{userBadge.authorizedBy}</span>
        </div>
        <div>
          <i className='fas fa-check'></i>
          {'  '} <span className='meta-title-verified fw-bold'>Verified</span>
        </div>
        <div className='image'>
          <img src={blockchainVerified} alt='' />
        </div>
      </div>
    </div>
  )
}

export default Verification
